module.exports = __webpack_public_path__ + "img/59a267c3-639f-4bf0-b886-7424387519f5.de16775f.jpg";